import cn from 'classnames';
import { type Toast } from '~/context';
import { type ToastPosition } from '~/types';
import { Toast as ToastComponent } from './Toast';

import css from './ToastPortal.module.css';

const positions: ToastPosition[] = [
  'top-left',
  'top-center',
  'top-right',
  'bottom-left',
  'bottom-center',
  'bottom-right',
];

interface ToastPortalProps {
  toasts: Toast[];
  removeToast: (id: string) => void;
}

export function ToastPortal({ toasts, removeToast }: ToastPortalProps) {
  return (
    <>
      {positions.map((position) => {
        const items = toasts.filter((t) => t.position === position);
        if (!items.length) return null;

        return (
          <div
            key={position}
            className={cn(css.container, css[`container--${position}`])}
          >
            {items.map((toast) => (
              <ToastComponent
                key={toast.id}
                {...toast}
                onClose={() => removeToast(toast.id)}
              />
            ))}
          </div>
        );
      })}
    </>
  );
}
